module.exports = __webpack_public_path__ + "img/dpd_open.a7b3cdee.svg";